module.exports = __webpack_public_path__ + "static/media/ZESCAN.dd42b4ad.svg";